export const qcNameOption = {
  filterBtn: true,
  card: true,
  emptyBtn: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: true,
  menu: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  searchSpan: 7,
  searchMenuSpan: 4,
  menuWidth: 100,
  column: [
    {
      label: '质控人',
      prop: 'realname',
      searchSpan: 4,
      searchLabelWidth: 60,
    },
    {
      label: '所属圈子',
      prop: 'circleName',
      overHidden: true,
      slot: true,
    },
    {
      label: '是否新人',
      prop: 'isNew',
      dicData: [
        {
          label: '是',
          value: '1',
        },
        {
          label: '否',
          value: '0',
        },
      ],
    },
    {
      label: '是否有进行中轻任务',
      prop: 'releaseTime',
      width: 220,
    },
    {
      label: '资源类型',
      prop: 'userType',
      dicData: [
        {
          label: '兼职',
          value: 'PT',
        },
        {
          label: '全职',
          value: 'FT',
        },
        {
          label: '团队',
          value: 'TT',
        },
        {
          label: '公司',
          value: 'CO',
        },
      ],
    },
    {
      label: '拉黑译员人数',
      prop: 'disableTrNum',
    },
  ],
};
